import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SearchObject} from 'src/app/domain/search/SearchObject';
import {urlJoin} from 'src/app/utils/urlJoin';
import {environment} from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ProjetprogService {


    constructor(private http: HttpClient) {
    }

    static get base() {
        return urlJoin(environment.server.hostSource, 'portail');
    }

    getProjetsList(): Observable<any> {
        const resource = urlJoin(ProjetprogService.base, 'vEpPlanMaster', 'data');
        return this.http.get(resource);
    }

    search(searchObject: SearchObject) {
        const resource = urlJoin(ProjetprogService.base, 'vEpPlanMaster', 'data');
        return this.http.post(resource, searchObject);
    }

    findByIdproj(id: number): Observable<any> {
        const resource = urlJoin(ProjetprogService.base, 'vEpPlanMaster', id);
        return this.http.get(resource);

    }
}
